/* eslint-disable max-len */
import * as React from 'react';

export const ExternalLink = props => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M10.2582 2.91667H8.5378V1.75H12.2499V5.4621H11.0832V3.74154L7.38573 7.43883L6.56079 6.61385L10.2582 2.91667Z" fill="currentColor" />
        <path
            d="M3.50985 2.9697C3.18229 2.9697 2.91667 3.23532 2.91667 3.56288V10.4901C2.91667 10.8177 3.18229 11.0833 3.50985 11.0833H10.4371C10.7647 11.0833 11.0303 10.8177 11.0303 10.4901V7.02636H12.1969V10.4901C12.1969 11.462 11.409 12.25 10.4371 12.25H3.50985C2.53796 12.25 1.75 11.462 1.75 10.4901V3.56288C1.75 2.59099 2.53796 1.80303 3.50985 1.80303H6.97362V2.9697H3.50985Z"
            fill="currentColor"
        />
    </svg>
);
